import { render, staticRenderFns } from "./BatteryWarningDetail.vue?vue&type=template&id=a8c4b8c6"
import script from "./BatteryWarningDetail.vue?vue&type=script&lang=js"
export * from "./BatteryWarningDetail.vue?vue&type=script&lang=js"
import style0 from "./BatteryWarningDetail.vue?vue&type=style&index=0&id=a8c4b8c6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports